import React from "react";
import { Col, FormGroup, ListGroupItem } from "reactstrap";
import { urlBase } from "../requests/utils";


export default class Inicio extends React.Component {
  constructor(props) {
    super(props);
    this.clic = this.clic.bind(this);
    this.generaCards = this.generaCards.bind(this);
    this.generaBacks = this.generaBacks.bind(this);
    this.state = {
      visibleSubs: false,
      subMenus: [],
    };
  }

  getSubReports = (parameters) => {
    if (parameters) {
      this.setState({ visibleSubs: true, subMenus: parameters });
    }
  };

  renderSubs = () => {
    const { subMenus } = this.state;

    return subMenus.map((a, index) => {
      let icono =
        a.imagen && a.imagen.length > 0
          ? urlBase + a.imagen
          : process.env.PUBLIC_URL + "/images/logo_tiii.png";
      let bg = a.imagen && a.imagen.length > 0 ? "" : "#ff0d0d";
      return (
        <Col md={3} lg={3} key={index} onClick={() => this.clic(a.idVista)}>
          <div className="dash_report sub_child sub_animate">
            <div className="body_report" style={{ backgroundColor: bg }}>
              <img src={icono} alt="#" />
            </div>
            <div className="text_report">
              <span>{a.descripcionMenu}</span>
            </div>
          </div>
        </Col>
      );
    });
  };

  generaCards() {
    if (this.props.menu !== null) {
      var apps = this.props.menu.filter(
        (m) => m.multivista === "True" && m.vistaPadre === 0
      );
      return apps.map((a, index) => {
        var reps = this.props.menu.filter(
          (m) => m.vistaPadre === a.idVista && m.multivista === "True"
        );
        let icono =
          a.imagen && a.imagen.length > 0 && a.imagen.length > 13
            ? urlBase + a.imagen
            : process.env.PUBLIC_URL + "/images/logo_tiii.png";
        let bg = a.imagen && a.imagen.length > 0 ? "" : "#ff0d0d";

        return (
          <Col
            md={3}
            lg={3}
            key={index}
            onClick={() => this.getSubReports(reps)}
          >
            <div className="dash_report">
              <div className="body_report" style={{ backgroundColor: bg }}>
                <img src={icono} alt="#" />
              </div>
              <div className="text_report">
                <span>{a.descripcionMenu}</span>
              </div>
            </div>
          </Col>
        );
      });
    }
  }

  generaBacks(reps) {
    return reps.map((r, index) => {
      return (
        <ListGroupItem
          key={index}
          idmenu={r.idVista}
          tag="button"
          onClick={(e) => this.clic(e)}
          action
        >
          {r.descripcionMenu}
        </ListGroupItem>
      );
    });
  }

  clic(id) {
    var opcion = this.props.menu.filter((m) => m.idVista === parseInt(id, 10));
    this.props.action(opcion[0]);
  }

  render() {
    const { visibleSubs } = this.state;
    return (
      <div className="dv_Inicio dash_reportes">
        <FormGroup row>
          {!visibleSubs ? this.generaCards() : this.renderSubs()}
        </FormGroup>
      </div>
    );
  }
}
